//helpers
import { dynamicParameter } from '@/mixins/service/mixin-service';
import cloneDeep from 'lodash/cloneDeep'
import dateFormatter from '@/services/formatter_services/date-formatter';
import get from 'lodash/get';
import set from 'lodash/set';
import restUtils from '@/utils/rest-utils.js';
import uniq from 'lodash/uniq';
import writeXlsxFile from 'write-excel-file';
import axios from 'axios';
import i18n from '@/language/i18n';
import { noHtmlTagsFormat } from '@/services/format-service';
//enums
import FORMAT_EXCEL_EXPORT_TYPE_ENUM from '@/services/formatter_services/enums/FORMAT_EXCEL_EXPORT_TYPE_ENUM'

export default function (notVisibleHeaders = []) {
    const getNotVisibleHeaders = dynamicParameter(notVisibleHeaders);
    const YES_NO = Object.freeze([
        { text: i18n.t('Common.yes'), stringValue: 'true', value: true },
        { text: i18n.t('Common.no'), stringValue: 'false', value: false },
    ]);

    return {
        props: {
            excelObjectDataPath: { type: String, default: 'data.' },
        },
        data() {
            return {
                filename: undefined,
            }
        },
        methods: {
            deepGet(obj, path) {
                return get(obj, path) ?? get(obj?.data, path);
            },  
            fetchExcelData() {
                let schema = [];
                let responseDataPath = this.excelObjectDataPath ?? '';
                
                const clonedHeaders = cloneDeep(this.internalHeaders ?? this.headers);
                const sortedHeaders = clonedHeaders.sort((header1, header2) => {
                const positionFilter1 = this.orderdHeaders.findIndex(
                    (_value) => _value === header1.value
                );
                const positionFilter2 = this.orderdHeaders.findIndex(
                    (_value) => _value === header2.value
                );
                return positionFilter1 - positionFilter2;
                });

                let filteredHeaders = sortedHeaders.filter(el => !getNotVisibleHeaders(this).includes(el.value));
                filteredHeaders.forEach((el) => {
                    let valPath = responseDataPath + el.value;
                    let cellType = el.type ? Number : String;
                    schema.push({
                        column: el.text,
                        value: item => {
                            let finalValue;
                            const value = this.deepGet(item, valPath);
                    
                            if (el.presentWithInExcelExport && value !== undefined) {
                                finalValue = el.presentWithInExcelExport(value, item?.data ?? item);
                            } else if (!el.presentWithRequiresParamItem && (value === undefined || value === null)) {
                                finalValue = '';
                            } else if (!el.presentWith) {
                                finalValue = value ? cellType(value) : '';
                            } else {
                                finalValue = cellType(el.presentWith(value, item?.data ?? item));
                            }
                            if (typeof finalValue === 'string') {
                                finalValue = finalValue.replace(/(\s\s+|\r\n|\n|\r)/g, ' ');
                            }
                            return finalValue;
                        },
                        getCellStyle: (obj) => ({
                            fontWeight: el.fontWeight ? el.fontWeight(obj) : 'normal'}),
                        type: cellType,
                        format: el.format != undefined ? el.format : (el.type === FORMAT_EXCEL_EXPORT_TYPE_ENUM.NUMBER ? '#,##0.0' : undefined),
                        path: valPath
                    });
                });

                this.filename = dateFormatter.getLocalDateTimeStringNow() + '_' + this.name;

                let sortOptions = {};
                for (let i = 0; i < this.sortBy.length; i++) {
                    sortOptions[this.sortBy[i]] = this.sortDesc[i];
                }
                const processedFilters = cloneDeep(this.filters) ?? [];
                for (const [key, value] of Object.entries(processedFilters)) {
                    if (Array.isArray(value)) {
                        processedFilters[key] = value.map(v => encodeURIComponent(v)).join(',');
                    }
                }
                if (this.search)
                    processedFilters['search'] = this.search

                if (this.path == 'reports/smartcontrolling')
                    processedFilters['export'] = true

                axios
                    .get('/rest/v4/' + this.path, {
                        params: {
                            ...processedFilters,
                            ...this.mandatoryFilters,
                            sort: restUtils.convertSortOptionsToQueryParam(sortOptions),
                            page: 0,
                            size: 9999
                        },
                    })
                    .then((response) => {
                        let responseDataItems = response.data.data;

                        if (this.path == 'contacts' || this.path == 'products') {
                            schema = schema.filter(item => item.path !== 'data.categoryNames' && item.path !== 'data.attributeValues' && item.path !== 'data.attributeNames');
                            
                            let categorySchemaHeaders = [];   
                            if (this.path == 'products')
                                categorySchemaHeaders = uniq(responseDataItems.map(item => item.data.categoryNames).flat());
                            else 
                                categorySchemaHeaders = uniq(responseDataItems.map(item => item.data.attributeNames).flat());   
                            
                            for (let categoryLabel of categorySchemaHeaders) {
                                if(categoryLabel === undefined) continue;
                                schema.push({
                                    column: categoryLabel,
                                    value: item => 
                                        YES_NO.find((booleanLabel) => 
                                            booleanLabel.value === (item.data.categoryNames?.includes(categoryLabel) || item.data.attributeNames?.includes(categoryLabel)))?.text,
                                    type: String
                                });  
                            }

                            let attributeSchemaHeaders = [];    
                            for (let attributeItem of responseDataItems.map(item => item.data.attributeValues).flat()) {
                                if (attributeItem === undefined || attributeSchemaHeaders.includes(attributeItem.label))
                                    continue;
                                
                                attributeSchemaHeaders.push(attributeItem.label);
                                schema.push({
                                    column: attributeItem.label,
                                    value: item => this._formatAttributeValues(attributeItem.label, item.data.attributeValues),
                                    type: String
                                });  
                            }
                        }

                        // strip html where possible
                        for (const item of responseDataItems) {
                            for (const schemaItem of schema) {
                                let path = schemaItem.path;
                                let value = get(item, path);
                                
                                if (value === undefined) {
                                    path = `data.${path}`;
                                    value = get(item, path);
                                }
                                
                                if (typeof value !== 'string')
                                    continue;

                                const newVal = noHtmlTagsFormat(value);
                                if (newVal !== undefined)
                                    set(item, path, newVal);
                            }
                        }

                        writeXlsxFile(responseDataItems, {
                            schema,
                            fileName: this.filename + '.xlsx',
                        });

                        if (this.path == 'devices') {
                            axios.put('/rest/v4/devices/export', {
                                data: {
                                    idList: responseDataItems.map((element) => element.id)
                                }
                            })
                        }
                        else if (this.path == 'reports/smartcontrolling') {
                            axios.put('/rest/v4/reports/smartcontrolling/export', {
                                data: {
                                    idList: responseDataItems.map((element) => element.activityId)
                                }
                            })
                        }
                    })
                    .catch((error) => {
                        window.console.error(error);
                    });
            },
            _formatAttributeValues(attributeLabel, attributeValues) {
                if (attributeValues === undefined || attributeValues === null || attributeValues.length === 0) 
                    return '';

                let itemValues = [];
                for (let item of attributeValues.filter(attributeValue => attributeValue.label === attributeLabel)) {
                    item.values.forEach((itemVal) =>
                        itemValues.push(
                            YES_NO.find((booleanLabel) => booleanLabel.stringValue == itemVal)?.text ?? itemVal
                        )
                    );
                }
                
                return itemValues.join(', ');
            },
        },
    }
}
